import { render, staticRenderFns } from "./school-form.vue?vue&type=template&id=1ad6dd1b"
import script from "./school-form.vue?vue&type=script&lang=js"
export * from "./school-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports